<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid add-new-product">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Edit Product</h4>
            <hr />
            <editProductForm></editProductForm>
            <router-view />
          </div>
        </transition>
      </div>
      <appModal></appModal>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import EditProductForm from "./EditProductForm.vue";
import Modal from "@/components/Modal.vue";
export default {
  name: "EditProduct",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    editProductForm: EditProductForm,
    appModal: Modal,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageProducts",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },

  destroyed() {
    this.$store.state.manageProducts.product = {};
  },
};
</script>
<style lang="scss" scoped>
.add-new-product {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
